const en = {
  title: 'Lyft Cities Talk Back',
  carouselItems: [
    {
      id: 'story-borderlands',
      title: 'Borderlands',
      location: 'San Diego-Tijuana Border',
      description: 'Waiting for America',
      imageSize1URL: 'assets/images/carousel/carousel-image-borderlands-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-borderlands-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/345139468.sd.mp4?s=f44835dbcf6ca40c8b273e807cd8ef65b58bb0b2&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344913411.sd.mp4?s=8a87d26b23bca91be184ae56ba716e8aca9e562e&profile_id=165',
      tickDescription:
        '<p>Seeking asylum in America is dangerous and marked by an almost interminable waiting—for a wholly uncertain fate.</p>'
    },
    {
      id: 'story-bad-hombre',
      title: 'Bad Hombre',
      location: 'Los Angeles, CA',
      description: 'Forever from Los Angeles',
      imageSize1URL: 'assets/images/carousel/carousel-image-badhombre-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-badhombre-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/345169298.sd.mp4?s=399e27884c2795481aecc79d78ec3bf1225025c2&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/345162331.sd.mp4?s=d0f7d3364ea3cb7763616517ad116fc7131882f5&profile_id=165',
      tickDescription:
        '<p>Wilson, a.k.a. Punch, was born in LA to Salvadoran parents. He builds lowriders—and he didn’t think he’d live past 21.</p>'
    },
    {
      id: 'story-twin-cities',
      title: 'Life After 1991',
      location: 'Twin Cities, MN',
      description: 'Diaspora in the Twin Cities',
      imageSize1URL: 'assets/images/carousel/carousel-image-twin-cities-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-twin-cities-1920.jpg',
      featureVideoURL: null, // NO FEATURE
      rolloverVideoURL:
        'https://player.vimeo.com/external/345095138.sd.mp4?s=1f2d61726cb7ea2c00e131b951ca03b9b573d4a9&profile_id=165',
      tickDescription:
        '<p>Somali immigrants landed in Minneapolis after the 1991 civil war—now they’re redefining themselves as Somali-Americans.</p>'
    },
    {
      id: 'story-cesar',
      title: 'Nine Numbers',
      location: 'Nashville, TN',
      description: 'Undocumented, but Not Invisible',
      imageSize1URL: 'assets/images/carousel/carousel-image-cesar-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-cesar-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344699878.sd.mp4?s=7ed73e4052345395d4a29f2d53f2ff61fe2d38de&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344700772.sd.mp4?s=e8b4b3719f9e4e2fd0904403aa5e037bb9f18fec&profile_id=165',
      tickDescription:
        '<p>Cesar was born in Mexico, and raised in Alabama, undocumented. He’s an American in every sense but on paper.</p>'
    },
    {
      id: 'story-shervin',
      title: "The '80s",
      location: 'San Jose, CA',
      description: 'After the Iranian Revolution',
      imageSize1URL: 'assets/images/carousel/carousel-image-shervin-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-shervin-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344700193.sd.mp4?s=aeab3664eb7f08266949b2326c62f3ac370ebbcf&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344700809.sd.mp4?s=03f44317b238802fa65f0cb857694e4651bb0be3&profile_id=165',
      tickDescription:
        '<p>Shervin was born in Iran and grew up in San Jose. He’s an ‘80s enthusiast, and collects cars and all kinds of memorabilia from the era.</p>'
    },
    {
      id: 'story-zahraa',
      title: 'My Three Sons',
      location: 'Los Angeles, CA',
      description: 'Muslim in America',
      imageSize1URL: 'assets/images/carousel/carousel-image-zahraa-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-zahraa-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344700461.sd.mp4?s=71fcc00b0b2807fcb5abd8651eb156f35f4de487&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344700838.sd.mp4?s=0890b719310b39fa3734adab1570b0f85ff3df9d&profile_id=165',
      tickDescription:
        '<p>Zahraa is a single mother, a Muslim, and an American. She lives in Los Angeles with her three sons.</p>'
    }
  ]
};

const es = {
  title: 'Lyft Cities Talk Back',
  carouselItems: [
    {
      id: 'story-borderlands',
      title: 'Fronteras',
      location: 'Frontera San Diego-Tijuana',
      description: 'Esperando a Estados Unidos',
      imageSize1URL: 'assets/images/carousel/carousel-image-borderlands-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-borderlands-1920.jpg',
      featureVideoURL: 'https://player.vimeo.com/external/350389796.sd.mp4?s=da21015ddad94c4baa6aaad982a0145c3728d29d&profile_id=165',
      rolloverVideoURL: 'https://player.vimeo.com/external/344913411.sd.mp4?s=8a87d26b23bca91be184ae56ba716e8aca9e562e&profile_id=165',
      tickDescription: '<p>Buscar asilo en Estados Unidos es peligroso y conlleva una espera casi interminable, por un destino totalmente incierto.</p>',
      // videoSubtitles: [
      //   {label: 'Spanish', lang: 'es', src: 'assets/subtitles/borderlands_hero.vtt'}
      // ]
    },
    {
      id: 'story-bad-hombre',
      title: 'Bad Hombre',
      location: 'Los Ángeles, CA',
      description: 'Eternamente desde Los Angeles',
      imageSize1URL: 'assets/images/carousel/carousel-image-badhombre-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-badhombre-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/356482968.sd.mp4?s=454b7d8522146a8996000a93ce7dee3be6be4855&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/345162331.sd.mp4?s=d0f7d3364ea3cb7763616517ad116fc7131882f5&profile_id=165',
      tickDescription:
        '<p>Wilson, alias Punch, nació en Los Ángeles y es de padres salvadoreños. Arma lowriders y no pensó que viviría más allá de los 21 años.</p>',
      // videoSubtitles: [
      //   {label: 'Spanish', lang: 'es', src: 'assets/subtitles/bad_hombre_hero.vtt'}
      // ]
    },
    {
      id: 'story-twin-cities',
      title: 'Después de 1991',
      location: 'Ciudades Gemelas, MN',
      description: 'Exodo a las Ciudades Gemelas',
      imageSize1URL: 'assets/images/carousel/carousel-image-twin-cities-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-twin-cities-1920.jpg',
      featureVideoURL: null, // NO FEATURE
      rolloverVideoURL:
        'https://player.vimeo.com/external/345095138.sd.mp4?s=1f2d61726cb7ea2c00e131b951ca03b9b573d4a9&profile_id=165',
      tickDescription:
        '<p>Los inmigrantes somalíes desembarcaron en Mineápolis después de la guerra civil de 1991, ahora se están redefiniendo a sí mismos como somalíes-estadounidenses.</p>'
    },
    {
      id: 'story-cesar',
      title: 'Nueve números',
      location: 'Nashville, TN',
      description: 'Sin documentos, pero no invisible',
      imageSize1URL: 'assets/images/carousel/carousel-image-cesar-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-cesar-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344699878.sd.mp4?s=7ed73e4052345395d4a29f2d53f2ff61fe2d38de&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344700772.sd.mp4?s=e8b4b3719f9e4e2fd0904403aa5e037bb9f18fec&profile_id=165',
      tickDescription:
      '<p>César nació en México y se crió en Alabama como indocumentado. Es estadounidense en todos los sentidos, menos en papel.</p>',
      videoSubtitles: [
        {label: 'Spanish', lang: 'es', src: 'assets/subtitles/cesar_hero.vtt'}
      ]
    },
    {
      id: 'story-shervin',
      title: 'Los ochenta',
      location: 'San Jose, CA',
      description: 'Despues de la revolucion irani',
      imageSize1URL: 'assets/images/carousel/carousel-image-shervin-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-shervin-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344700193.sd.mp4?s=aeab3664eb7f08266949b2326c62f3ac370ebbcf&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344700809.sd.mp4?s=03f44317b238802fa65f0cb857694e4651bb0be3&profile_id=165',
      tickDescription:
        '<p>Shervin nació en Irán y creció en San José. Es amante de los años ochenta, colecciona automóviles y todo tipo de recuerdos de esa época.</p>',
      videoSubtitles: [
        {label: 'Spanish', lang: 'es', src: 'assets/subtitles/shervin_hero.vtt'}
      ]
    },
    {
      id: 'story-zahraa',
      title: 'Mis tres hijos',
      location: 'Los Ángeles, CA',
      description: 'Una musulmana en Estados Unidos',
      imageSize1URL: 'assets/images/carousel/carousel-image-zahraa-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-zahraa-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344700461.sd.mp4?s=71fcc00b0b2807fcb5abd8651eb156f35f4de487&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344700838.sd.mp4?s=0890b719310b39fa3734adab1570b0f85ff3df9d&profile_id=165',
      tickDescription:
        '<p>Zahraa es una madre soltera musulmana y estadounidense. Vive en Los Ángeles con sus tres hijos.</p>',
      videoSubtitles: [
        {label: 'Spanish', lang: 'es', src: 'assets/subtitles/zahraa_hero.vtt'}
      ]
    }
  ]
};

export default {en, es};
